import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BACK } from '../constants/testIds';

// Back button — uses history.back() when possible, falls back to /
export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname === '/') return null;

  const handle = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-[128px] md:pt-[160px]">
      <button
        onClick={handle}
        data-testid={BACK.root}
        className="shine-wrap inline-flex items-center gap-2 glass-light px-3 h-9 font-mono text-[10px] tracking-[0.22em] uppercase text-white/80 hover:text-white transition-colors"
      >
        <ArrowLeft size={13} strokeWidth={1.5} />
        Retour
      </button>
    </div>
  );
}
